import React from "react";
import { Helmet } from "react-helmet-async";
import { COMPANY, SOCIALS } from "@/data/company";

// schema.org LocalBusiness JSON-LD — rendered once at the root layout.
const StructuredData = () => {
  const data = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "@id": "https://www.lutrom.co.uk/#business",
    name: COMPANY.name,
    legalName: COMPANY.legalName,
    url: "https://www.lutrom.co.uk",
    logo: "https://www.lutrom.co.uk/brand/lutrom-logo-white.png",
    image: "https://www.lutrom.co.uk/gallery/lutrom-machines.jpg",
    telephone: COMPANY.phone.display,
    email: COMPANY.email.display,
    priceRange: "$$",
    address: {
      "@type": "PostalAddress",
      streetAddress: `${COMPANY.address.line1}, ${COMPANY.address.line2}`,
      addressLocality: COMPANY.address.city,
      postalCode: COMPANY.address.postcode,
      addressCountry: "GB",
    },
    areaServed: [
      { "@type": "AdministrativeArea", name: "North West England" },
      { "@type": "Country", name: "United Kingdom" },
    ],
    openingHoursSpecification: [
      {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday",
        ],
        opens: "00:00",
        closes: "23:59",
        description: "24/7 call-out",
      },
    ],
    sameAs: SOCIALS.map((s) => s.href),
    identifier: {
      "@type": "PropertyValue",
      propertyID: "Companies House",
      value: COMPANY.companyNumber,
    },
    description:
      "Lutrom Engineering delivers 24/7 mechanical, electrical, hydraulic, pneumatic, water systems, automation, welding, fabrication and bespoke machinery services to industrial and commercial clients across North West England.",
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(data)}</script>
    </Helmet>
  );
};

export default StructuredData;
